import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function NotAuthorizedPage() {
  const { t } = useTranslation('core.nav');
  const navigate = useNavigate();

  return (
    <div className="flex h-full min-h-[400px] w-full flex-col items-center justify-center gap-4 p-6 bg-[var(--color-bg)]">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[var(--color-surface)] border border-[var(--color-border)]">
        <Lock size={20} className="text-[var(--color-text-secondary)]" aria-hidden />
      </div>
      <div className="text-center">
        <p className="text-[14px] font-medium text-[var(--color-text-primary)]">
          {t('not_authorized_title')}
        </p>
        <p className="mt-1 text-[13px] text-[var(--color-text-secondary)]">
          {t('not_authorized_description')}
        </p>
      </div>
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-2 rounded-[4px] border border-[var(--color-border)] bg-[var(--color-bg)] px-4 py-2 text-[13px] font-medium text-[var(--color-text-primary)] hover:bg-[var(--color-surface)]"
      >
        {t('not_authorized_back')}
      </button>
    </div>
  );
}
